import script from "./ClientAddUnionDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddUnionDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientAddUnionDropdown.vue?vue&type=style&index=0&id=a784bb28&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a784bb28"]])

export default __exports__